<mat-card appearance="outlined">
  <mat-card-content>
    <div class="row">
      <div class="col-sm-12" *ngIf="isSubmitted">
        <h3>Thank you!</h3>
      </div>
      <div class="col-sm-12" *ngIf="!isSubmitted">
        <h3>Oops! Something went wrong.</h3>
      </div>
    </div>
    <div class="row" *ngIf="isSubmitted && applicationId">
      <div class="col-sm-12">
        Your application is now in progress.<br>
        Your application reference number is <strong>{{applicationId}}</strong>.<br>
        The application form will be sent via an email shortly.
        <br /><br />
      </div>
    </div>
    <div class="row" *ngIf="isSubmitted && !applicationId">
      <div class="col-sm-12">
        Your application could not be submitted.<br />
        Please resubmit or contact us for assistance
        <br /><br />
      </div>
    </div>
    <div class="row" *ngIf="!isSubmitted">
      <div class="col-sm-12">
        Your application was not submitted.<br />
        Please try resending it again at a later time.
      <br /><br />
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <button mat-raised-button type="button" color="primary" (click)="redirect()" class="fmc-button-primary">Back to home page</button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
